
/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/
/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../../components/GrayPanel';
import Paper from '../../../../components/Paper';
import FormRow from '../../../../components/FormRow';
import ModalAlert from '../../../../components/ModalAlert';
import s from './EditAvailableService.css';

import { fetchAvailableServices } from '../../../../actions/eservices';
import { adminEndpoint } from '../../../../config';

const btnStyles = { margin: '10px' };

class EditAvailableService extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {
    shortName: '',
    title: '',
    description: '',
    requiresLicence: false,
    requiresUserInfo: false,
    requiresEPUAP: false,
    requiresProton: false,
    isEnabled: false,
    demoURL: null,
    iconURL: null,
    shouldRedirect: false,
  }

  componentDidMount = () => fetch(this.fetchURL).then(r => {
    if (r.status === 200) {
      return r.json();
    } else {
      throw r.text();
    }
  })
    .then(resp => {
      this.setState({ ...resp });
    })

  fetchURL = `${process.env.API_URL}/available_service/${this.props.params.id}`;
  redirectURL = `${adminEndpoint}/available_services`;

  onChange = (e, callback = null) => this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }, callback);

  renderIcon = () => {
    const url = this.state.iconURL;
    if (!url) return;
    const startsWithCondition = (url.startsWith('http') || url.startsWith('https'));
    const endsWithCondition = (url.endsWith('.jpg') || url.endsWith('.JPG') || url.endsWith('.png') || url.endsWith('.PNG'));
    if (startsWithCondition && endsWithCondition) {
      return <img role="presentation" src={this.state.iconURL} />;
    }
    if (url.startsWith('fa-')) {
      return <i className={`fa ${url} fa-4x`} aria-hidden="true" />;
    }
    return null;
  }
  onHide = () => this.setState({ showModal: false }, () => {
    if (this.state.shouldRedirect) {
      window.location.href = this.redirectURL;
    }
  });
  save = () => fetch(this.fetchURL,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state),
    },
  )
    .then(r => {
      if (r.status === 200) {
        return r.json();
      } else {
        throw r.text();
      }
    })
    .then(resp => {
      this.setState({ modalText: 'Zapisano pomyślnie.', modalTitle: 'Status dodania usługi', showModal: true, shouldRedirect: true })
    })
    .catch(err => {
      err.then(a => this.setState({ modalText: a, modalTitle: 'Błąd', showModal: true, shouldRedirect: false }));
    });

  render() {
    return (
      <Paper title={this.props.title}>
        <div className="row">
          <div className="col-sm-2" />
          <div className="col-sm-8">
            <hr />
            <FormRow label="Krótka nazwa" name="shortName" onChange={e => this.onChange(e)} value={this.state.shortName} />
            <FormRow label="Tytuł" name="title" onChange={e => this.onChange(e)} value={this.state.title} />
            <FormRow label="Opis" name="description" type="textarea" onChange={e => this.onChange(e)} value={this.state.description} />
            <FormRow label="Czy wymaga licencji ?" name="requiresLicence" type="checkbox" onChange={e => this.onChange(e)} value={this.state.requiresLicence} />
            <FormRow label="Czy wymaga danych użytkownika ?" name="requiresUserInfo" type="checkbox" onChange={e => this.onChange(e)} value={this.state.requiresUserInfo} />
            <FormRow label="Czy może być z integrowana z EPUAP'em ?" name="requiresEPUAP" type="checkbox" onChange={e => this.onChange(e)} value={this.state.requiresEPUAP} />
            <FormRow label="Czy może być z integrowana z protonem ?" name="requiresProton" type="checkbox" onChange={e => this.onChange(e)} value={this.state.requiresProton} />
            <FormRow label="Czy usługa jest włączona ?" name="isEnabled" type="checkbox" onChange={e => this.onChange(e)} value={this.state.isEnabled} />
            <FormRow label="URL prezentacji usługi" name="demoURL" onChange={e => this.onChange(e)} value={this.state.demoURL} />
            <FormRow label="Ikona" name="iconURL" onChange={e => this.onChange(e)} value={this.state.onChange} />
            {this.renderIcon()}
            <hr />
            <div className="pull-right">
              <a href={this.redirectURL} style={btnStyles} className="btn btn-danger">Anuluj</a>
              <button type="submit" onClick={() => this.save()} style={btnStyles} className="btn btn-warning">Zapisz</button>
            </div>
          </div>
          <div className="col-sm-2" />
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalText}
          show={this.state.showModal}
          name="statusModal"
          onHide={() => this.onHide()}
        />
      </Paper>
    );
  }
}

const mapState = (state) => ({
  availableServices: state.eservices.availableServices,
});
const mapDispatch = {
  fetchAvailableServices,
};

export default withStyles(s)(connect(mapState, mapDispatch)(EditAvailableService));



// WEBPACK FOOTER //
// src/routes/admin/available_services/edit_availableservice/EditAvailableService.js